import { gql } from "@apollo/client";

const GET_TRIAL_PACKAGE = gql`
  query trialPackages {
    trialPackages {
      id
      status
      currency
      languageId
      priceId
      endDate
    }
  }
`;

export default GET_TRIAL_PACKAGE;
